import { useQuery } from '@tanstack/react-query';
import type { AuditEntry } from '@figureit/shared';
import { api } from '../api/client';
import { fmtDate } from '../utils/format';

export function AuditView() {
  const { data, isLoading } = useQuery({
    queryKey: ['audit'],
    queryFn: () => api<{ items: AuditEntry[] }>('/api/audit?limit=200'),
  });
  if (isLoading) return <div className="p-6 text-text2">Loading…</div>;
  const items = data?.items ?? [];
  return (
    <div className="p-3 md:p-6 overflow-y-auto overscroll-contain h-full">
      <h2 className="text-lg font-bold mb-4">Audit log</h2>
      {items.length === 0 && <div className="text-text3">No audit entries yet.</div>}
      <div className="space-y-1.5">
        {items.map((a) => (
          <div
            key={a.id}
            className="bg-surface2 border border-border rounded-md px-3 py-2 text-sm flex flex-wrap items-baseline gap-x-3 gap-y-0.5"
          >
            <span className="text-text3 text-xs w-16 md:w-24 flex-shrink-0">
              {fmtDate(a.createdAt)}
            </span>
            <span className="text-text2 md:w-32 flex-shrink-0 truncate max-w-[40%]">
              {a.userName ?? '—'}
            </span>
            <span className="text-accent2 font-medium flex-shrink-0">{a.action}</span>
            <span className="text-text3 text-xs truncate w-full md:w-auto md:flex-1 min-w-0">
              {formatChange(a)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function formatChange(a: AuditEntry): string {
  const f = a.fromValue == null ? '—' : JSON.stringify(a.fromValue);
  const t = a.toValue == null ? '—' : JSON.stringify(a.toValue);
  if (a.fromValue == null && a.toValue == null) return '';
  if (a.fromValue == null) return `→ ${t}`;
  return `${f} → ${t}`;
}
